import { render, staticRenderFns } from "./addAddres.vue?vue&type=template&id=57b65195&scoped=true"
import script from "./addAddres.vue?vue&type=script&lang=js"
export * from "./addAddres.vue?vue&type=script&lang=js"
import style0 from "./addAddres.vue?vue&type=style&index=0&id=57b65195&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b65195",
  null
  
)

export default component.exports